export default {
  construction: 'Em construção.',
  menu: {
    item1: 'Congresso',
    item2: 'Local',
    item3: 'Submissões',
    item4: 'Inscrições',
    item5: 'Datas',
    item6: 'Notícias',
    items1: [
      { title: 'Apresentação' },
      { title: 'Organização' },
      { title: 'Programação' },
      { title: 'Convidados' },
      { title: 'Comissão científica' },
      { title: 'Anais' },
      { title: 'Certificados' },
    ],
    items3: [
      { title: 'Temas e tópicos' },
      { title: 'Submissão de resumos' },
      { title: 'Resumos aceitos' },
      { title: 'Submissão de artigos' },
      { title: 'Artigos aceitos' },
      { title: 'Instruções para apresentações' },
    ],
  },
  content: {
    items1: [
      {
        text: 'O PLURIS representa a continuidade da parceria entre pesquisadores do Brasil e de'
        + ' Portugal que se realiza desde 2005. Constitui-se em uma associação técnico-científica, de'
        + ' caráter multidisciplinar, reunindo profissionais que atuam principalmente nos seguintes'
        + ' temas: Ambiente e Energia; Cidades Inovadoras e Inteligentes; Mobilidade e Transportes e'
        + ' Planejamento Regional e Urbano. <br><br>'
        + 'Precedido pelo PLURIS 2018, realizado em Coimbra (Portugal), o Congresso bianual tem'
        + ' sua nona edição a ser realizada no Brasil e originalmente seria sediada na cidade de Águas'
        + ' de Lindóia, nos dias 07, 08 e 09 de abril de 2021. Entretanto, face aos efeitos da pandemia'
        + ' do COVID-19, o congresso será realizado no formato digital. O evento é aberto aos diversos'
        + ' perfis de participantes: pesquisadores, estudantes e profissionais ligados aos temas e'
        + ' tópicos abordados. Assim, a sua nova edição em 2021 pretende reforçar e enriquecer os'
        + ' contatos estabelecidos nas edições anteriores e integrar novos participantes cujos trabalhos'
        + ' acadêmicos e profissionais se enquadrem nas áreas temáticas do congresso. <br><br>'
        + 'O tema do PLURIS 2021, <i>"Pequenas cidades, grandes desafios, múltiplas oportunidades"</i>'
        + ' procura enaltecer a grande maioria das cidades dos territórios brasileiro e português. Sabe-'
        + 'se que o processo de urbanização é frequentemente associado aos grandes centros'
        + ' urbanos, mas tal processo ocorre também em cidades de pequeno porte demográfico.'
        + ' Consequentemente, essas cidades também merecem atenção em relação ao planejamento'
        + ' das áreas de habitação, saneamento básico, educação, saúde, mobilidade, segurança,'
        + ' proteção ambiental e preservação do patrimônio histórico e cultural, pois estes aspectos'
        + ' interferem na qualidade de vida dos seus habitantes.<br><br>'
        + 'O atual desafio das cidades de pequeno porte é proporcionar um desenvolvimento urbano,'
        + ' ambiental, econômico e cultural sob o viés sustentável. Em função de sua escala, menor'
        + ' extensão territorial e menor população, esses municípios têm como diferencial em relação'
        + ' às demais cidades a implementação de ações de planejamento mais efetivas, fator esse'
        + ' que poderia contribuir para assegurar melhor qualidade de vida aos cidadãos.<br><br>'
        + 'Esperamos ter o prazer de nos encontrarmos no PLURIS 2021, em seu formato digital.<br><br>'
        + 'Saudações da Coordenação Local,<br><br>'
        + 'Renata Cardoso Magagnin<br>'
        + 'Maria Solange Gurgel de Castro Fontes<br>'
        + 'Gustavo Garcia Manzato<br>'
        + 'Universidade Estadual Paulista Júlio de Mesquita Filho (UNESP)',
      },
      {
        text: '<b>COORDENAÇÃO PERMANENTE DO PLURIS</b><br><br>'
        + '<b>Coordenadores da Comissão Científica</b><br><br>'
        + 'PROF. DR. ANTÔNIO NÉLSON RODRIGUES DA SILVA<br>'
        + 'Universidade de São Paulo - BR<br>'
        + 'anelson@sc.usp.br<br><br>'
        + 'PROF. DR. RUI ANTÓNIO RODRIGUES RAMOS<br>'
        + 'Universidade do Minho - PT<br>'
        + 'rui.ramos@civil.uminho.pt<br><br>'
        + 'PROFA. DRA. LÉA CRISTINA LUCAS DE SOUZA<br>'
        + 'Universidade Federal de São Carlos - BR<br>'
        + 'leacrist@ufscar.br<br><br>'
        + '<b>Coordenador de Apoio à Informática</b><br><br>'
        + 'PROF. DR. DANIEL SOUTO RODRIGUES<br>'
        + 'Universidade do Minho - PT<br>'
        + 'dsr@civil.uminho.pt<br><br><br>'
        + '<b>COORDENAÇÃO EXECUTIVA LOCAL</b><br><br>'
        + 'Renata Cardoso Magagnin<br>'
        + 'Maria Solange Gurgel de Castro Fontes<br>'
        + 'Gustavo Garcia Manzato<br>'
        + 'Universidade Estadual Paulista Júlio de Mesquita Filho (UNESP)<br>',
        title1: 'COMISSÃO PERMANENTE',
        title2: 'COMISSÃO EXECUTIVA LOCAL',
        contentContinuation: '<br><br><b>DESENVOLVIMENTO DA IDENTIDADE VISUAL DO PLURIS 2020/2021</b><br><br>'
        + '<b>INKY DESIGN</b><br>'
        + 'Marina de Araujo (discente - criação)<br>'
        + 'Natália Schiavon (discente - criação)<br>'
        + 'Profa. Dra. Cássia Carrara Domiciano (Coordenação)<br>'
        + 'Profa. Dra. Fernanda Henriques (Coordenação)<br><br><br>'
        + '<b>DESENVOLVIMENTO WEBSITE PLURIS 2020/2021</b><br><br>'
        + 'Bianca Dias Barbosa (discente)<br><br><br>'
        + '<b>SUPORTE COM FERRAMENTAS DIGITAIS</b><br><br>'
        + 'Cíntia Machado de Oliveira<br>',
      },
      {
        wednesday: 'QUARTA-FEIRA',
        thursday: 'QUINTA-FEIRA',
        friday: 'SEXTA-FEIRA',
        morning: 'M<br>A<br>N<br>H<br>Ã',
        afternoon: 'T<br>A<br>R<br>D<br>E',
        evening: 'N<br>O<br>I<br>T<br>E',
        startingat17h: 'A partir das 17h',
        schedule: [
          'Credenciamento <br>Recepção dos Congressistas',
          'Sessões Temáticas <br>Sessão de pôsteres',
          'Sessões Temáticas',
          '<b>Minicurso 1 <br> ou <br> Minicurso 2</b>',
          'Abertura<br>',
          'Intervalo para café',
          'Conferência<br>',
          'Intervalo Almoço',
          'Sessões Temáticas <br>Exposição de pôsteres',
          'Encerramento',
          'Café de encerramento',
          'Coquetel de boas-vindas',
          'Jantar',
        ],
        text: 'Clique <a href="/programacao.pdf" download>aqui</a> para baixar a programação em PDF.',
      },
      {
        text: ' ',
      },
      {
        text: 'Ademir Paceli Barbassa<br>'
        + 'Adriana Capretz<br>'
        + 'Alan Ricardo da Silva<br>'
        + 'Alessandra Rodrigues Prata-Shimomura<br>'
        + 'Alexandre Marques<br>'
        + 'Ana Bastos<br>'
        + 'Ana Elisabete de Almeida Medeiros<br>'
        + 'Ana Maria Guerra Seráfico Pinheiro<br>'
        + 'Ana Paula Camargo Larocca<br>'
        + 'Anabela Salgueiro Narciso Ribeiro<br>'
        + 'Andrea Ribeiro<br>'
        + 'Anna Silvia Palcheco Peixoto<br>'
        + 'António Armando Lima Sampaio Duarte<br>'
        + 'António José Pais Antunes<br>'
        + 'António Manuel de Sousa Baltazar Mortal<br>'
        + 'Antonio Nelson Rodrigues da Silva<br>'
        + 'Arminda Maria Marques Almeida<br>'
        + 'Ary Ferreira da Silva<br>'
        + 'Augusto Brasil<br>'
        + 'Barbara Stolte Bezerra<br>'
        + 'Bernardo Arantes do Nascimento Teixeira<br>'
        + 'Bianca Carla Dantas de Araújo<br>'
        + 'Bruno Bertoncini<br>'
        + 'Caio Frederico E silva<br>'
        + 'Camila Mayumi Nakata-Osaki<br>'
        + 'Carlos Alberto Bragança dos Santos<br>'
        + 'Carmen Velásquez Marea<br>'
        + 'Cira Souza Pitombo<br>'
        + 'Claudia Cotrim Pezzuto<br>'
        + 'Cláudia Mariz de Lyra Barroso Krause<br>'
        + 'Daniel Souto Rodrigues<br>'
        + 'Denise Balestrero Menezes<br>'
        + 'Diogenes Cortijo Costa<br>'
        + 'Douglas Barreto<br>'
        + 'Eduardo Oliveira<br>'
        + 'Eliane Viviani<br>'
        + 'Elio Trusiani<br>'
        + 'Erich Kellner<br>'
        + 'Érico Masiero<br>'
        + 'Erika Cristine Kneib<br>'
        + 'Fabiana Serra de Arruda<br>'
        + 'Fabiola Aguiar<br>'
        + 'Fernando Cavalcanti<br>'
        + 'Flávia Araújo<br>'
        + 'Francisco Manuel Camarinhas Serdoura<br>'
        + 'Fred Rodrigues<br>'
        + 'Frederico Yuri Hanai<br>'
        + 'Geovany Jessé Alexandre da Silva<br>'
        + 'Gianna Melo Barbirato<br>'
        + 'Gustavo Garcia Manzato<br>'
        + 'Ilce Marilia Dantas Pinto<br>'
        + 'Ilza Machado Kaiser<br>'
        + 'Irineu da Silva<br>'
        + 'Jefferson Oliveira Goulart<br>'
        + 'João Carlos<br>'
        + 'João Roberto Gomes de Faria<br>'
        + 'José Alberto Tostes<br>'
        + 'José Aparecido Sorratini<br>'
        + 'José da Costa Marques Neto<br>'
        + 'José Leomar Fernandes Júnior<br>'
        + 'José Manuel Ferreira da Silva<br>'
        + 'Josiane Palma Lima<br>'
        + 'Júlia Maria Brandão Barbosa Lourenço<br>'
        + 'Juliana Michaello<br>'
        + 'Karin Regina de Castro Marins<br>'
        + 'Léa Cristina Lucas de Souza<br>'
        + 'Leandro Cardoso<br>'
        + 'Lenise Grando Goldner<br>'
        + 'Leonardo Herszon Meira<br>'
        + 'Leonardo Marques Monteiro<br>'
        + 'Licinio da Silva Portugal<br>'
        + 'Lígia Conceição<br>'
        + 'Lindon Fonseca Matias<br>'
        + 'Lúcia Hidaka<br>'
        + 'Luzenira Alves Brasileiro<br>'
        + 'Magaly Romão<br>'
        + 'Maisa Tobias<br>'
        + 'Manuela Fernanda Gomes Moreira da Silva<br>'
        + 'Marcio Dagosto<br>'
        + 'Marcos Thadeu Queiroz Magalhães<br>'
        + 'María José Prados<br>'
        + 'Maria Manuela de Oliveira Guedes de Almeida<br>'
        + 'Maria Manuela Rosa<br>'
        + 'Maria Manuela Santos Natário<br>'
        + 'Maria Solange Gurgel de Castro Fontes<br>'
        + 'Maria Teresa Françoso<br>'
        + 'Mario Angelo Nunes de Azevedo Filho<br>'
        + 'Marta Cristina de Jesus Albuquerque Nogueira<br>'
        + 'Mateus Araujo e Silva<br>'
        + 'Mauro Normando Macêdo Barros Filho<br>'
        + 'Nair Cristina Margarido Brondino<br>'
        + 'Nívea Adriana Dias Pons<br>'
        + 'Norma Regina Truppel Constantino<br>'
        + 'Nuno Pinto<br>'
        + 'Orlando Strambi<br>'
        + 'Oswaldo Cavalcanti da Costa Lima Neto<br>'
        + 'Pablo Brilhante de Sousa<br>'
        + 'Paula Remoaldo<br>'
        + 'Paulo César Lima Segantine<br>'
        + 'Paulo Jorge Gomes Ribeiro<br>'
        + 'Paulo Roberto Masseran<br>'
        + 'Renata Cardoso Magagnin<br>'
        + 'Renato da Silva Lima<br>'
        + 'Ricardo Trevisan<br>'
        + 'Rodrigo Nóbrega<br>'
        + 'Rômulo José da Costa Ribeiro<br>'
        + 'Ronaldo Balassiano<br>'
        + 'Rui António Rodrigues Ramos<br>'
        + 'Rui Gama Fernandes<br>'
        + 'Samir Hernandes Tenorio Gomes<br>'
        + 'Sandra Regina Mota Silva<br>'
        + 'Sérgio Gomes<br>'
        + 'Sérgio Luiz Garavelli<br>'
        + 'Sidnei Pereira da Silva<br>'
        + 'Simone Becker Lopes<br>'
        + 'Teresa Cristina de Almeida Faria<br>'
        + 'Vasco Barbosa<br>'
        + 'Waldemir Rodrigues Costa Júnior<br>'
        + 'Waldir José Gaspar<br>'
        + 'Wellington Mary<br>',
      },
      {
        text: 'Clique <a href="/anais.pdf" download>aqui</a> para acessar a versão final dos Anais.',
      },
      {
        text: 'Clique <a href="/certificados.pdf" download>aqui</a> para acessar os certificados do PLURIS 2021.',
      },
    ],
    items2: [
      {
        text: '<b>Congresso Digital</b><br><br>'
        + 'O PLURIS 2021 será realizado no formato digital.<br><br>'
        + '<a href="https://plurisdigital.ciente.live/login/" target="_blank">Clique aqui</a>'
        + ' para acessar a plataforma das atividades do congresso.',
      },
    ],
    items3: [
      {
        text: '<b>TEMAS</b><br><br>'
        + '<b>1. AMBIENTE E ENERGIA</b> <br>'
        + '<b>2. CIDADES INOVADORAS E INTELIGENTES</b> <br>'
        + '<b>3. MOBILIDADE E TRANSPORTE</b> <br>'
        + '<b>4. PLANEJAMENTO REGIONAL E URBANO</b> <br><br>'
        + '<b>TÓPICOS RELACIONADOS AOS TEMAS</b> <br><br>'
        + '01 Acessibilidade e mobilidade urbanas<br>'
        + '02 Algoritmos genéticos<br>'
        + '03 Ambiente do espaço construído<br>'
        + '04 Análise espacial<br>'
        + '05 Aspectos ambientais do transporte<br>'
        + '06 Autômatos celulares<br>'
        + '07 Cidades e regiões digitais<br>'
        + '08 Clima e planejamento urbanos<br>'
        + '09 Conforto ambiental em espaços urbanos<br>'
        + '10 Ecologia urbana<br>'
        + '11 Educação e transferência de tecnologia<br>'
        + '12 Energia e planejamento urbano<br>'
        + '13 Ergodesign e usabilidade nos espaços urbanos<br>'
        + '14 Estatística espacial<br>'
        + '15 Geomática aplicada à gestão do território<br>'
        + '16 Gestão ambiental<br>'
        + '17 Gestão de infraestruturas<br>'
        + '18 Inclusividade dos espaços urbanos<br>'
        + '19 Integração entre uso do solo e transportes<br>'
        + '20 Logística<br>'
        + '21 Planejamento auxiliado por computador<br>'
        + '22 Planejamento e gestão do uso do solo<br>'
        + '23 Planejamento, organização e sustentabilidade em eventos<br>'
        + '24 Planejamento sustentável<br>'
        + '25 Qualidade de vida urbana<br>'
        + '26 Questões socioeconômicas<br>'
        + '27 Redes neurais artificiais<br>'
        + '28 Reabilitação ambiental urbana<br>'
        + '29 Simulações ambientais<br>'
        + '30 Sistemas de apoio à decisão<br>'
        + '31 Sistemas de apoio ao planejamento<br>'
        + '32 Sistemas de emergência e segurança em meio urbano<br>'
        + '33 Sistemas de informação<br>'
        + '34 Sistemas de informação geográfica<br>'
        + '35 Sistemas de posicionamento global<br>'
        + '36 Sustentabilidade em transportes<br>'
        + '37 Turismo e espaço urbano<br>'
        + '38 Efeitos urbanos e regionais e políticas públicas decorrentes da COVID-19<br>'
        + '<br>',
      },
      {
        text: '<b>NOVA CHAMADA DE TRABALHOS</b><br><br>'
        + 'Exclusiva para o tema: <b>"Efeitos urbanos e regionais e'
        + ' políticas públicas decorrentes da COVID-19"</b>.<br><br>'
        + 'Os Resumos devem ser submetidos até <b>1 de junho de 2020.</b><br><br>'
        + 'Os Resumos devem ter uma extensão de 300 a 500 palavras e descrever com clareza a'
        + ' natureza, relevância e objetivos do trabalho, a metodologia, modelo ou técnica utilizadas e'
        + ' os resultados.<br><br>'
        + 'O formulário para envio de resumos está disponível em: <u><a target="_blank" href="http://www.civil.uminho.pt/planning/pluris2020/subm_resumos/resumos_covid.aspx">'
        + ' http://www.civil.uminho.pt/planning/pluris2020/subm_resumos/resumos_covid.aspx </a></u><br><br>',
      },
      {
        text: 'A lista com os títulos dos resumos aceitos pode ser consultada no link: <br>'
        + '<u><a target="_blank" href="http://www.civil.uminho.pt/planning/pluris2020/lista_de_resumos_aprovados_2020.pdf">'
        + ' http://www.civil.uminho.pt/planning/pluris2020/lista_de_resumos_aprovados_2020.pdf</a></u><br><br>'
        + '<b>A lista com os títulos dos resumos aceitos para a chamada especial "Efeitos'
        + ' urbanos e regionais e políticas públicas decorrentes da COVID-19" pode ser'
        + ' consultada no link:</b>'
        + '<u><a target="_blank" href="http://www.civil.uminho.pt/planning/pluris2020/Lista_de_resumos_covid_aprovados_2020.pdf">'
        + ' http://www.civil.uminho.pt/planning/pluris2020/Lista_de_resumos_covid_aprovados_2020.pdf</a></u><br><br>'
        + '“Qualquer dúvida quanto à aprovação de resumos e artigos deve ser encaminhada'
        + ' para o e-mail específico da coordenação científica permanente:'
        + ' <u><a>pluriscientifico@gmail.com</a></u>"<br><br>'
        + 'Os artigos completos devem ser enviados até o dia <b>08 de setembro de 2020</b>.'
        + ' Ver modelo para formatação dos artigos na aba "Submissão de Artigos".',
      },
      {
        text: 'Todos os autores cujos resumos passaram para a fase de avaliação do'
        + ' Trabalho Completo devem submeter os seus artigos para dar continuidade ao'
        + ' processo de avaliação.<br><br>'
        + 'Ressalta-se que somente serão considerados para o evento os trabalhos'
        + ' aceitos após a segunda etapa de avaliação.<br><br>'
        + 'Os Trabalhos Completos devem ser submetidos até <b>8 de setembro de 2020</b>.<br><br>'
        + 'Todos os autores devem seguir as normas definidas nas instruções disponíveis'
        + ' nos arquivos seguintes:<br><br>'
        + '<strike>Arquivo em PDF (novo)</strike><br>'
        + '<strike>Arquivo em WORD (novo)</strike><br><br>'
        + 'O tamanho máximo do Trabalho Completo é de 12 páginas, incluindo figuras,'
        + ' tabelas e referências, conforme as normas definidas nas instruções para'
        + ' submissão.<br><br>'
        + 'Salientamos que artigos acima deste limite serão liminarmente recusados,'
        + ' independentemente da sua qualidade, uma vez que não serão sequer'
        + ' apreciados pelo comitê de avaliadores.<br><br>'
        + 'Para a submissão dos artigos completos, por favor, clique no link:<br><br>'
        + '<strike>Submissão de artigos completos</strike>',
      },
      {
        text: 'A lista com os títulos dos artigos completos aceitos pode ser consultada no link:<br>'
        + '<a href="http://www.civil.uminho.pt/planning/pluris2020/Lista_de_artigos_aprovados_2021.pdf" target="_blank">http://www.civil.uminho.pt/planning/pluris2020/Lista_de_artigos_aprovados_2021.pdf</a>'
        + '<br><br><b>“Qualquer dúvida quanto à aprovação de resumos e artigos deve ser encaminhada'
        + ' para o e-mail específico da coordenação científica permanente: '
        + '<a href="#">pluriscientifico@gmail.com</a>"</b><br><br>'
        + 'A versão final dos artigos completos devem ser enviados até o dia <b>10 de dezembro de 2020.</b>'
        + ' Rever o modelo para formatação dos artigos na aba "<b>Submissão de Artigos</b>".<br><br>'
        + '<b>Atenção:</b> Apenas os artigos aceitos (oral ou poster) com autores inscritos no evento serão'
        + ' publicados nos Anais do PLURIS 2021.<br><br>'
        + 'Autores inscritos na <b>categoria profissional</b> poderão registrar <b>até dois artigos.</b><br><br>'
        + 'Autores inscritos na <b>categoria estudante (graduação ou pós-graduação)</b> poderão'
        + ' registrar <b>um artigo.</b><br><br>'
        + '<b>Autores que tenham mais artigos aprovados:</b><br><br>'
        + 'Para autores inscritos na categoria profissional com mais de dois artigos ou autores inscritos'
        + ' na categoria estudante (graduação ou pós-graduação) com mais de um artigo, <b>um dos'
        + ' COAUTORES deverá fazer a inscrição para ter assegurada a publicação nos Anais do evento. </b><br><br>'
        + ' Não garantimos a publicação de artigos cujos autores façam a inscrição depois de <b>29 de janeiro de 2021</b>.',
      },
      {
        text: '<b>Normas para apresentação assíncrona e síncrona</b>'
        + '<br><br>Disponibilizamos, de forma sugestiva, o modelo para formatação das lâminas'
        + ' (slides) dos trabalhos aprovados no 9º Congresso Luso Brasileiro para o'
        + ' Planejamento Urbano, Regional, Integrado e Sustentável – PLURIS 2021'
        + ' DIGITAL para apresentações assíncrona e síncrona.<br><br>'
        + 'Modelo apresentação - <a href="/template_pluris.pptx" download>'
        + 'Clique aqui.</a><br><br>'
        + '<b>Detalhes das apresentações assíncronas</b><br><br>'
        + 'As sessões técnicas do PLURIS 2021 DIGITAL serão assíncronas e estarão disponíveis'
        + ' na forma de vídeo.<br><br>'
        + 'Os vídeos deverão ter <b>duração máxima de 10 minutos</b>, o som deverá ter volume'
        + ' adequado e qualidade para ser compreendido e o <b><i>primeiro slide</b></i> deverá'
        + ' conter o título do trabalho, todos os autores e suas afiliações.<br><br>'
        + 'Você poderá usar qualquer ferramenta de gravação de imagem da sua tela e webcam:'
        + ' Zoom, Google Meet, Loom, etc.<br><br>'
        + 'O vídeo deverá ser gravado em um notebook ou desktop, com uma boa webcam ou'
        + ' webcam de computador. <b>Não recomendamos a gravação de celular, devido à'
        + ' necessidade de inclusão de slides de apresentação.</b><br><br>'
        + 'Após a gravação, você deve postar o vídeo no youtube na privacidade <b>"não listado"'
        + ' </b> e enviar o seu link através de um formulário específico.<br><br>'
        + '<a href="https://submissao.ciente.live/pluris/" target="_blank">Clique aqui</a>'
        + ' para ter acesso ao formulário e à todas as informações necessárias para submissão'
        + ' do seu vídeo. Este canal estará disponível de 09 à 25 de março de 2021.',
      },
    ],
    items4: [
      {
        text: 'Valores da Inscrição Individual (em reais).',
        titleH1: '<b>Até 29 de janeiro <br> de 2021</b>',
        titleH2: '<b>Após 29 de janeiro <br> de 2021 até o <br> evento</b>',
        titleV1: '<b>Autor/Profissional<br></b> (com direito a registrar até 2 trabalhos)',
        titleV2: '<b>Autor/Estudante de Pós-Graduação<br></b> (com direito a registrar 1 trabalho)',
        titleV3: '<b>Autor/Estudante Graduação <br></b> (com direito a registrar 1 trabalho)',
        information: '<br><br><b>INFORMAÇÕES:</b><br><br>'
        + 'Os estudantes de graduação e Pós-Graduação precisam comprovar a sua situação '
        + 'com documento válido emitido pelas respectivas faculdades ou universidades.<br><br>'
        + 'Esse documento deve ser anexado na plataforma de inscrição.',
        subscribe: 'INSCREVA-SE AQUI',
      },
    ],
    items5: [
      {
        text: '<b>31 de outubro de 2019</b> | 1ª Chamada de Trabalhos.<br><br>'
        + ' <b>25 de novembro de 2019</b> | 2ª Chamada de Trabalhos.<br><br>'
        + ' <b>20 de janeiro de 2020</b> | 3ª Chamada de Trabalhos.<br><br>'
        + ' <b>17 de fevereiro de 2020</b> | Data limite para submissão de resumos.<br><br>'
        + ' <b>23 de março de 2020</b> | Notificação de aceitação ou rejeição de resumos.<br><br>'
        + ' <b>08 de maio de 2020</b> | Data limite para submissão de artigos completos.<br><br>'
        + ' <b>15 de junho de 2020</b> | Notificação de aceitação ou rejeição de artigos.<br><br>'
        + ' <b>03 de agosto de 2020</b> | Data limite para envio da versão final de trabalhos completos.<br><br>'
        + ' <b>10 de agosto de 2020</b> | Data limite para inscrição de um dos autores e inscrição dos demais participantes com taxa diferenciada.<br><br>'
        + ' <b>07 a 09 de outubro de 2020 | PLURIS 2020 no Hotel Monte Real em Águas de Lindóia - São Paulo - Brasil.<br><br> </b>',
        date1: '31 de outubro de 2019',
        date2: '25 de novembro de 2019',
        date3: '20 de janeiro de 2020',
        date4: '<span style="color: #939598"><strike>17 de fevereiro de 2020</strike></span><br>28 de fevereiro de 2020',
        date5: '23 de março de 2020',
        date6: '<span style="color: #939598"><strike>08 de maio de 2020</strike></span>'
        + '<br>08 de setembro de 2020',
        date7: '<span style="color: #939598"><strike>15 de junho de 2020</strike></span>'
        + '<br><b>31 de outubro de 2020</b>',
        date8: '<span style="color: #939598"><strike>03 de agosto de 2020</strike></span>'
        + '<br>10 de dezembro de 2020',
        date9: '<span style="color: #939598"><strike>10 de agosto de 2020</strike></span>'
        + '<br>29 de janeiro de 2021',
        date10: '<span style="color: #939598"><b><strike>07 a 09 de outubro de 2020</b></strike></span>'
        + '<br><b>07 a 09 de abril de 2021</b>',
        title1: ' 1ª Chamada de Trabalhos.',
        title2: ' 2ª Chamada de Trabalhos.',
        title3: ' 3ª Chamada de Trabalhos.',
        title4: ' Data limite para submissão de resumos.<br><br>',
        title5: ' Notificação de aceitação ou rejeição de resumos.',
        title6: ' Data limite para submissão de artigos completos.',
        title7: ' <b>Notificação de aceitação ou rejeição de artigos.</b>',
        title8: ' Data limite para envio da versão final de trabalhos completos.',
        title9: ' Data limite para inscrição de um dos autores e inscrição dos demais participantes com taxa diferenciada.',
        title10: '<b> PLURIS 2021 <strike>no Hotel Monte Real em Águas de Lindóia - São Paulo - Brasil</strike>'
        + ' <span style="color: #0189d0">Digital</span>.</b>',
        dateX1: '01 de junho de 2020',
        dateX2: '22 de junho de 2020',
        titleX1: 'Data limite para submissão de resumos.',
        titleX2: 'Notificação de aceitação ou rejeição de resumos.',
        titleNewCall: '<br><b>NOVA CHAMADA DE TRABALHOS</b>',
      },
    ],
    items6: [
      {
        date1: '31/10/2019',
        title1: 'Primeira chamada para submissão de resumos.',
        link1: '',
        date2: '25/11/2019',
        title2: 'Segunda chamada para submissão de resumos.',
        link2: '',
        date3: '20/01/2020',
        title3: 'Terceira chamada para submissão de resumos.',
        link3: '',
        date4: '14/02/2020',
        title4: 'Nova data limite para submissão de resumos: ',
        link4: '',
        extension4: '28 de fevereiro de 2020.',
        date5: '23/03/2020',
        link5: '',
        title5: 'Notificação de aceitação ou rejeição de resumos.',
        date6: '27/03/2020',
        link6: 'Acesse aqui.',
        coord6: [3, 3],
        title6: 'O modelo para formatação do artigo completo está disponível em Submissões > Submissão de Artigos:',
        date7: '07/04/2020',
        link7: 'Acesse aqui.',
        coord7: [3, 3],
        title7: 'O link para envio do artigo completo está disponível em Submissões > Submissão de Artigos:',
        date8: '04/05/2020',
        link8: '',
        title8: 'Em função da pandemia causada pelo COVID-19, associada à'
        + ' atual indefinição de quando a situação será amenizada, a comissão'
        + ' organizadora do PLURIS 2020 decidiu transferir o congresso para o período de 7'
        + ' a 9 de abril de 2021. Assim, pretende-se atender às orientações da Organização'
        + ' Mundial de Saúde, no sentido de reduzir riscos associados com a aglomeração'
        + ' de pessoas.',
        date9: '04/05/2020',
        link9: 'Acesse aqui.',
        coord9: [5, 0],
        title9: 'Novas datas do PLURIS 2021.',
        date10: '04/05/2020',
        link10: 'Acesse aqui.',
        coord10: [3, 1],
        title10: 'Nova chamada para submissão de Trabalhos, exclusiva ao tema'
        + ' "Efeitos urbanos e regionais e políticas públicas decorrentes da COVID-19".',
        date11: '04/05/2020',
        link11: 'Acesse aqui.',
        coord11: [3, 3],
        title11: 'O novo template está disponível em Submissões > Submissão de Artigos.',
        date12: '22/06/2020',
        link12: 'Acesse aqui.',
        coord12: [3, 2],
        title12: 'Notificação de aceitação ou rejeição de resumos da chamada especial.',
        date13: '30/09/2020',
        link13: '',
        title13: 'Informamos que a notificação de resultados da revisão dos trabalhos'
        + ' completos submetidos ao PLURIS 2021 foi prorrogada para o dia 31 de outubro de 2020.',
        date14: '31/10/2020',
        link14: 'Acesse aqui.',
        coord14: [3, 4],
        title14: 'Notificação de aceitação ou rejeição dos artigos completos.',
        date15: '31/10/2020',
        link15: '',
        title15: 'Em função da continuidade da situação de incertezas sobre a pandemia'
        + ' do COVID-19, a comissão organizadora do PLURIS 2021 decidiu alterar o congresso'
        + ' para o formato digital. Novas taxas de inscrição serão informadas, bem como um'
        + ' novo programa do evento será elaborado, mas as datas permanecem inalteradas (de 7'
        + ' a 9 de abril de 2021).',
        date16: '12/11/2020',
        link16: '',
        title16: 'Os autores devem atualizar o template do artigo para a nova versão, pois o'
        + ' cabeçalho foi alterado. '
        + '<a href="/template_pluris_pt.docx" download>Acesse aqui.</a>'
        + ' OBS: A submissão dos artigos finais deve ser feita por meio do link'
        + '  individual que a comissão científica enviou a cada autor por e-mail.',
        date17: '27/11/2020',
        link17: 'Acesse aqui.',
        coord17: [4, 0],
        title17: 'As inscrições para o PLURIS 2021 Digital estão abertas!',
        date18: '04/03/2021',
        link18: 'Clique aqui.',
        coord18: [3, 5],
        title18: 'Para obter o template de formatação de apresentações:',
        date19: '05/03/2021',
        link19: '',
        title19: 'Saiba como será o PLURIS 2021 totalmente digital! ',
        date20: '08/03/2021',
        link20: '',
        title20: 'O PLURIS 2021 DIGITAL está chegando e, com ele, muitas'
        + ' novidades! Saiba como será a programação científica do evento!',
        date21: '09/03/2021',
        link21: 'Clique aqui.',
        coord21: [3, 5],
        title21: 'Envie a apresentação do seu trabalho. Saiba mais!  ',
        date22: '18/03/2021',
        link22: '',
        title22: 'Nota de Falecimento Profa Júlia Lourenço.',
        date23: '25/03/2021',
        link23: 'Clique aqui.',
        coord23: [1, 2],
        title23: 'Programação final. ',
        date24: '05/04/2021',
        link24: 'Clique aqui.',
        coord24: [1, 5],
        title24: 'Confira a Versão Preliminar dos Anais do PLURIS 2021.',
        date25: '06/04/2021',
        link25: '',
        title25: 'Confira a Programação Final dos Painéis Temáticos.</b> <a href="/programacao_paineis.pdf" download>Clique aqui.</a>',
        date26: '06/04/2021',
        link26: '',
        title26: 'PARA TER ACESSO À PLATAFORMA VIRTUAL DO PLURIS 2021,'
        + ' <a href="https://plurisdigital.ciente.live/login/"'
        + ' target="_blank">CLIQUE AQUI.</a>',
        date27: '12/05/2021',
        link27: 'clique aqui.',
        coord27: [1, 6],
        title27: 'Para acessar os certificados do PLURIS 2021, ',
        date28: '<b>21/05/2021</b>',
        link28: 'clique aqui.',
        coord28: [1, 5],
        title28: '<b>Para acessar a versão definitiva dos Anais do PLURIS 2021, </b>',
      },
    ],
  },
};
